import { StyledIcon } from 'components/elements/Icon/Icon.styled';
import { css, styled } from 'styles';
import { headerHeight } from './Table.config';
import { BaseTableCell } from './TableCell.styled';
import { StyledTableHeaderColumnProps, TableCellAlignment } from './types';

const centerStyle = css`
  justify-content: center;

  ${StyledIcon} {
    margin-left: ${({ theme }) => theme.spacing.absolute.tiny};
  }
`;

const leftStyle = css`
  justify-content: flex-start;

  ${StyledIcon} {
    margin-left: ${({ theme }) => theme.spacing.absolute.tiny};
  }
`;

const rightStyle = css`
  flex-direction: row-reverse;
  justify-content: flex-start;

  ${StyledIcon} {
    margin-right: ${({ theme }) => theme.spacing.absolute.tiny};
  }
`;

const sortableStyle = css`
  cursor: pointer;
`;

const sortDescStyle = css`
  ${StyledIcon} {
    transform: rotateX(180deg);
  }
`;

const getCellStyles = (align?: TableCellAlignment) => {
  switch (align) {
    case 'right':
      return rightStyle;
    case 'center':
      return centerStyle;
    case 'left':
    default:
      return leftStyle;
  }
};

export const TableHeaderColumnResizer = styled.div`
  bottom: 10%;
  cursor: col-resize;
  position: absolute;
  right: 0;
  top: 10%;
  touch-action: none;
  width: 3px;
  z-index: 1;
`;

export const StyledTableHeaderColumn = styled(BaseTableCell)<StyledTableHeaderColumnProps>`
  color: ${({ theme }) => theme.table.header.color};
  display: flex;
  font-size: 0.85em;
  font-weight: 600;
  height: ${headerHeight}px;
  padding: 0 ${({ theme }) => theme.spacing.absolute.smaller};
  position: relative;
  text-transform: uppercase;
  user-select: none;

  ${({ $align }) => getCellStyles($align)};
  ${({ $sortable }) => $sortable && sortableStyle};
  ${({ $sort }) => $sort === 'desc' && sortDescStyle};

  ${StyledIcon} {
    font-size: 1.2em;
  }

  &:not(:last-child)::after {
    border-left: thin solid ${({ theme }) => theme.table.header.color};
    bottom: 25%;
    content: '';
    opacity: 0.5;
    position: absolute;
    right: 0;
    top: 25%;
  }
`;

TableHeaderColumnResizer.displayName = 'TableHeaderColumnResizer';
StyledTableHeaderColumn.displayName = 'TableHeaderColumn.Styled';
